<template>
  <div class="card thank-card">
    <eyebrow-icon v-if="true" v-bind:eyebrowicon="{'icon':'star-outline', 'color':'black'}" v-bind:align="'center'"></eyebrow-icon>
    <h4>Thank you for sharing!</h4>
    <div class="pt-3 group row">
        <div class="col" style="position: relative">
            <span class="thank-sub-message">You can close this browser window to return to previous page.</span>
        </div>
    </div>
  </div>
</template>
<style scoped>
.thank-sub-message{
  font-family: "Plus Jakarta Sans";
  font-weight: 700;
  font-size: 15px;
} 

</style>
<script>
    export default {
        name: 'thankyou-message',
        mounted() {
          //$(".is-chrome .product_review_form").css("background-size","800px");
        },
    }
</script>
